<template>
  <div class="IntroduceWrap">
    <div class="SwiperWrap">
      <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
      <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img6.jpg"></swiper-slide>
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-1.jpg"></swiper-slide>
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-2.jpg"></swiper-slide>
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-3.jpg"></swiper-slide>
        <div class="swiper-pagination flex" slot="pagination"></div>
      </swiper>
      <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
    </div>
    <div class="CaseWrap">
      <div class="CaseTitle">
        <p>GOEASY <span>SOLUTION</span></p>
      </div>
      <div class="ListWrap flexa">
        <ul>
          <li @click="openYLurl">
            <i><img src="../../assets/Home/f_1.png"></i>
            <p>产业链数字化运营框架</p>
          </li>
          <li>
            <i><img src="../../assets/Home/f_2.png"></i>
            <p>种植产业链数字化方案</p>
          </li>
          <li>
            <i><img src="../../assets/Home/f_3.png"></i>
            <p>家具定制产业链数字化方案</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'introduce',
    components: {},
    data() {
      return {
        Flag: '1',
        swiperOptions: {
          slidesPerView: 1.13,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
      };
    },
    methods: {
      openYLurl() {
        this.OpenUrl('https://zywl.goeasy.cn');
      },

      OpenUrl(url) {
        window.open(url, '_blank');
      },
      Tab(tab) {
        this.Flag = tab;
      }
    }
  };
</script>
<style scoped lang="scss">
  @import '../../../public/Value';
  .IntroduceWrap{
    width: 100%;
    .ListWrap{
      width: 100%;
      margin: 0.05rem auto 0;
      ul{
        li{
          width: 1.06rem;
          height: 0.7rem;
          background:linear-gradient(to Right,#4d4c87, #3b3d93);
          border-radius: 0.08rem;
          float: left;
          margin-right: 0.05rem;
          margin-bottom: 0.05rem;
          position: relative;
          i{
            height: 0.22rem;
            margin: 0.08rem;
            img{
              height: 100%;
            }
          }
          p{
            position: absolute;
            width: 0.4rem;
            font-size: $SmallTitleSize;
            font-weight: bold;
            color: #fff;
            right: 0.06rem;
            bottom: 0.08rem;
            line-height: 0.08rem;
          }
        }
        li:nth-child(3n){
          margin-right: 0;
        }
      }
    }
    .SwiperWrap {
      width: 100%;
      height: 1.3rem;
      position: relative;
      overflow: hidden;
      .swiper-pagination {
        width: 100%;
        height: 0.1rem;
        position: absolute;
        bottom: 0.02rem;
        ::v-deep .swiper-pagination-bullet-active {
          background-color: #fff !important;
        }
        ::v-deep .swiper-pagination-bullet {
          width: 0.15rem;
          height: 0.02rem;
          opacity: 1;
          margin: 0 0.02rem;
          background-color: #4d4d4d;
          border-radius: 0.03rem;
        }
      }

      .LeftShadow, .RightShadow {
        height: 100%;
        position: absolute;
        z-index: 2;

        img {
          height: 100%;
          transform: scale(1.1);
        }
      }

      .LeftShadow {
        left: -0.1rem;
        top: 0;
      }

      .RightShadow {
        right: -0.1rem;
        top: 0;
      }

      .SwiperList {
        width: 100%;
        height: 100%;

        .ImgWrap {
          border-radius: 0.1rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.1rem;
          }
        }
      }
    }
    .CaseWrap{
      width: 88%;
      margin: 0.2rem auto 0;
      .zz{
        width: 100%;
        margin: 0.2rem 0;
        img{
          width: 100%;
        }
      }
      .CaseTitle{
        width: 100%;
        border-bottom: 2px solid #fff;
        p{
          font-size: $TitleSize;
          color: #fff;
          padding-bottom: 0.04rem;
          span{
            opacity: 0.6;
            font-weight: normal;
          }
        }
      }
    }
  }
</style>
